<template>
<!-- eslint-disable max-len -->
<div
  style="
    position: absolute;
    bottom: calc(100% - 18px);
    left: 32px;
  "
>
  <div
    v-if="showNameplate"
    class="nameplate"
    :style="nameplateStyle"
  >
    <span v-html="nameplateText"></span>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    character: { type: Object },
    player: { type: Boolean },
  },
  computed: {
    ...mapGetters([
      'selectedAvatar',
      'game',
    ]),
    char() {
      return (this.player && this.selectedAvatar) ? this.selectedAvatar : (this.character || {});
    },
    showNameplate() {
      return this.game.useNameplates && (!(this.player) || this.game.usePlayerNameplate) && !!(this.nameplateText);
    },
    nameplateText() {
      return (this.player && this.game.playerNameplateText)
        ? this.game.playerNameplateText
        : (this.char.nameplateText || this.char.title);
    },
    nameplateStyle() {
      return {
        height: this.game.nameplateHeight ? this.game.nameplateHeight : undefined,
        width: this.game.nameplateWidth ? this.game.nameplateWidth : undefined,
        color: this.game.nameplateTextColor ? this.game.nameplateTextColor : 'white',
        background:
          this.game.nameplateBackgroundImage
            ? `url(${this.resolveAssetPath(this.game.nameplateBackgroundImage, 'backgrounds')})`
            : (this.game.nameplateBackgroundColor ? this.game.nameplateBackgroundColor : 'black'),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.nameplate {
  white-space: nowrap;
  background-size: 100% 100%; // same behavior as object-fit: fill
  padding: 0 32px;
  font-size: 90%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Nameplate.vue